import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';
import account from './account';
import awards from './awards';
import books from './books';
import classrooms from './classrooms';
import flashMessage from './flash-messages';
import invitations from './invitations';
import messages from './messages';
import orders from './orders';
import readings from './readings';
import schools from './schools';
import subscriptions from './subscriptions';
import tips from './tips';
import users from './users';

export default combineReducers({
  account,
  awards,
  books,
  classrooms,
  flashMessage,
  invitations,
  messages,
  orders,
  readings,
  schools,
  subscriptions,
  tips,
  users,
  routing: routerReducer,
  form: formReducer,
});
